export default __webpack_public_path__ + "static/media/Mongodb.53fa45a7.svg";